// extracted by mini-css-extract-plugin
export default {"primaryColorBase":"#003869","primaryColorLight":"#03457f","primaryColorLighter":"#106dbf","primaryColorLightest":"#3394e8"};